import { acceptInvite } from '../../actions/passwordReset';
import SetPasswordForm from './SetPasswordForm';

export default function AcceptInvite() {
  return (
    <SetPasswordForm
      thunk={acceptInvite}
      side={{
        eyebrow: 'Account activation',
        headline: 'Set your password to finish activating.',
        paragraph:
          'Choose a strong password you don’t use elsewhere. Once it’s set we’ll sign you straight in to your workspace.',
      }}
      bracket="[ Account · Activation ]"
      headline="Activate your account."
      lede="Set a password to finish activating your account. Minimum 10 characters."
      ctaLabel="Set password & sign in →"
      requestNewLinkTo="/activate"
      errorHeadline="This link is no longer valid."
      errorBody="This activation link has expired or already been used. Request a fresh one and we’ll email you a new setup link."
    />
  );
}
